"use client"

import Link from "next/link"
import Image from "next/image"

import blackLogo from "/public/images/logotype-dark-side.webp"
import whiteLogo from "/public/images/logotype-light-side.webp"
import { useState, useEffect } from "react"

interface FootProps {
  lang: string
}

const Footer: React.FC<FootProps> = ({ lang }) => {
  const [translations, setTranslations] = useState<any>(null)

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const response = await fetch(`/api/translations/${lang}`)
        const data = await response.json()
        setTranslations(data)
      } catch (error) {
        console.error("Failed to fetch translations:", error)
      }
    }
    fetchTranslations()
  }, [lang])

  if (!translations) {
    return null
  }

  const currentYear = new Date().getFullYear()

  return (
    <>
      <div className="footer-area pt-175 pb-150">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4">
              <div className="footer-single-widget mw-310">
                <Link href="/" className="logo d-inline-block">
                  <Image
                    src={blackLogo}
                    className="d-block dark-none"
                    alt="logo"
                  />
                  <Image
                    src={whiteLogo}
                    className="d-none dark-block"
                    alt="logo"
                  />
                </Link>

                <p>
                  {translations.common?.foot?.description ||
                    "Tu escapada serena frente al mar en Añasco, Puerto Rico. Disfruta de nuestra amplia piscina, cómodas instalaciones y acceso exclusivo a la playa."}
                </p>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="row">
                <div className="col-lg-4 col-sm-6"></div>

                <div className="col-lg-4 col-sm-6"></div>

                <div className="col-lg-4 col-sm-6">
                  <div className="footer-single-widget">
                    <h3>
                      {translations.common?.foot?.title ||
                        "Información Oficial"}
                    </h3>

                    <ul className="p-0 m-0 list-unstyled info-official">
                      <li className="d-flex">
                        <i className="ri-map-pin-2-fill"></i>
                        <div className="ms-3">
                          <h4>
                            {translations.common?.foot?.section1?.title ||
                              "Localización"}
                            :
                          </h4>
                          <span>
                            {translations.common?.foot?.section1?.data ||
                              "Carr. 401 km 2.6 Barrio Playa Añasco, Puerto Rico  00610"}
                          </span>
                        </div>
                      </li>
                      <li className="d-flex">
                        <i className="ri-mail-fill"></i>
                        <div className="ms-3">
                          <h4>
                            {translations.common?.foot?.section2?.title ||
                              "Correo Electrónico"}
                            :
                          </h4>
                          <a href="mailto:info@yukayekeplaya.com">
                            {translations.common?.foot?.section2?.data ||
                              "info@yukayekeplaya.com"}
                          </a>
                        </div>
                      </li>
                      <li className="d-flex">
                        <i className="ri-phone-fill"></i>
                        <div className="ms-3">
                          <h4>
                            {translations.common?.foot?.section3?.title ||
                              "Teléfono"}
                            :
                          </h4>
                          <a href="tel:(+1)7876912322">
                            {translations.common?.foot?.section3?.data ||
                              "(+1) 787-691-2322"}
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copy-right-area">
        <div className="container">
          <p>
            © <span>{translations.common?.foot?.name || "Yukayeke Inc."}</span>{" "}
            {currentYear}
          </p>
        </div>
      </div>
    </>
  )
}

export default Footer
